import useColors from "../../../../api/hooks/useColors";
import PrimaryButton from "../../../../components/buttons/PrimaryButton";

const OffboardCustomerButton = ({ handleOnClick }) => {
  const colors = useColors();

  return (
    <PrimaryButton
      onClick={handleOnClick}
      style={{
        color: colors.common_white,
        backgroundColor: colors.error_main,
        borderRadius: "8px",
        border: "none",
        fontWeight: "bold",
      }}
      size="small"
    >
      Offboard Customer (RESTRICTED)
    </PrimaryButton>
  );
};

export default OffboardCustomerButton;
